<template>
  <TemplateRegistro :titulo="titulo" @intro="submit()">
    <label class="texto"> Dínos si podemos comunicarnos contigo </label>
    <div class="textoGdpr">
      <label>
        Para recibir promociones de MMT Seguros y empresas colaboradoras
      </label>
      <label>
        <input type="radio" value="true" v-model="gdprEmpresas" /> Si
        <input type="radio" value="false" v-model="gdprEmpresas" /> No
      </label>
      <br />
    </div>
    <PanelMensajes :mensaje="error" clase="error" />
    <button class="pure-button boton" @click="validar()">Finalizar</button>
    <div v-if="errorGdpr" class="noValido">{{ errorGdpr }}</div>
  </TemplateRegistro>
</template>

<script>
export default {
  data() {
    return {
      cliente: this.$store.state.portfolio.cliente,
      error: "",
      titulo: "Comunicaciones",
      errorGdpr: "",
      gdprEmpresas: this.$store.state.portfolio.cliente.gdprEmpresas,
    };
  },

  methods: {
    actualizaGdpr: async function () {
      console.log(this.gdprEmpresas);
      await this.$store.dispatch("actualizaGdpr", {
        gdprEmpresas: this.gdprEmpresas,
      });
      this.$store.dispatch("getPortfolio");
      this.$store.dispatch("getUrlClubMMT");
      this.$router.replace({ name: "inicio" });
    },

    validar() {
      if (this.gdprEmpresas == null) {
        this.error = "Conteste a las opciones, por favor";
        return;
      } else {
        this.error = "";
      }
      this.actualizaGdpr();
    },
  },
};
</script>
<style lang="scss" scoped>
.gdpr {
  min-width: 18rem;
}
.texto {
  font-size: 90%;
  margin-bottom: 1rem;
  color: $azulOscuroMMT;
}
.textoGdpr {
  font-size: 90%;
}
</style>
